// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__3rs1R","subheader":"ReorderModal_subheader__3vMFx","listWrap":"ReorderModal_listWrap__3bet_"};